import ButtonBase, { ButtonProps } from '@mui/material/Button';

export const Button = (props: ButtonProps) => (
  <ButtonBase
    {...props}
    sx={{
      borderRadius: '8px',
      textTransform: 'none',
      boxShadow: 'none',
    }}
  />
);
